import Typography, { TypographyProps } from '@mui/material/Typography';

import pkg from '../../../package.json';

// The release version: the Cut release workflow bumps it in package.json.
export default function AppVersion({ sx, ...props }: TypographyProps) {
  return (
    <Typography
      variant="caption"
      sx={[{ opacity: 0.4 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
      {...props}
    >
      v{pkg.version}
    </Typography>
  );
}
